// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609210759/js/" + chunkId + "." + {"44":"29dd6162","225":"efe616f0","481":"a9b792b3","486":"1a3b0500","770":"b521caa6"}[chunkId] + ".0.17687632149520371.chunk.js";
};